/* eslint-disable */
import React, { useState } from "react";
import "../../styles/Bars/SideBar/Sidebar.style.css";
import NavNestedMenu from "../../components/Bars/NavNestedMenu.component";
import NavItem from "../../components/Bars/NavItem.component";

import ORGLogo from "../../assets/Images/Org-logo.png";

//import all icons
import OrganizationalIm from "../../assets/Icons/Sidebar/Organizational.svg";
import { ReactComponent as ManagementIm } from "../../assets/Icons/Sidebar/Management.svg";
import { ReactComponent as NotificationIm } from "../../assets/Icons/Sidebar/Notification.svg";
import { ReactComponent as SettingIm } from "../../assets/Icons/Sidebar/Setting.svg";
import { ReactComponent as AlumniIm } from "../../assets/Icons/Sidebar/Alumni.svg";

import OperationalIm from "../../assets/Icons/Sidebar/Operational.svg";
import { ReactComponent as AcademicIm } from "../../assets/Icons/Sidebar/Alumni.svg";
import { ReactComponent as ResidentialIm } from "../../assets/Icons/Sidebar/Residential.svg";
import { ReactComponent as TransportationIm } from "../../assets/Icons/Sidebar/Transportation.svg";
import { ReactComponent as WorkshopIm } from "../../assets/Icons/Sidebar/Workshop.svg";

import FinancialIcon from "../../assets/Icons/Sidebar/Financeicon.svg";
import { ReactComponent as AccountentIm } from "../../assets/Icons/Sidebar/Accountent.svg";
import { ReactComponent as CashInFlowIm } from "../../assets/Icons/Sidebar/CashInflow.svg";
import { ReactComponent as CashOutFlowIm } from "../../assets/Icons/Sidebar/CashOutflow.svg";
const Sidebar = () => {
  const [nestedSideBar, setNestedSideBar] = useState([
    {
      title: "Organizational",
      icon: OrganizationalIm,
      children: [
        {
          title: "Management",
          icon: <ManagementIm className="managementIcon" />,
          path: "/organizational/management/",
          state: "Management",
        },
        {
          title: "Alumni",
          icon: <AlumniIm className="alumniIcon" />,
          path: "/organizational/Alumni/staffs",
          state: "Alumni",
        },
      ],
    },
    {
      title: "Operational",
      icon: OperationalIm,
      children: [
        {
          title: "Academic",
          icon: <AcademicIm className="sidebarIcons" />,
          path: "/operational/academic",
          state: "Academic",
        },
        {
          title: "Residential",
          icon: <ResidentialIm className="sidebarIcons" />,
          path: "/operational/residential",
          state: "Residential",
        },
        {
          title: "Transportation",
          icon: <TransportationIm className="sidebarIcons" />,
          path: "/operational/transportation/dashboard",
          state: "Transportation",
        },
        {
          title: "Workshop",
          icon: <WorkshopIm className="sidebarIcons" />,
          path: "/operational/workshop/dashboard",
          state: "Workshop",
        },
      ],
    },
    {
      title: "Financial",
      icon: FinancialIcon,
      children: [
        {
          title: "Accountent",
          icon: <AccountentIm className="managementIcon" />,
          path: "/finance/accountent/",
          state: "Accountent",
        },
        {
          title: "Cash inflow",
          icon: <CashInFlowIm className="managementIcon" />,
          path: "/finance/cashinflow/",
          state: "Cashinflow",
        },
        {
          title: "Cash outflow",
          icon: <CashOutFlowIm className="managementIcon" />,
          path: "/finance/cashoutflow/",
          state: "Cashoutflow",
        },
      ],
    },
  ]);

  return (
    <div className="sidebar" style={{ width: `${264}px` }}>
      <div className="sideBarContent">
        <div className="logoSec">
          <img src={ORGLogo} alt="Org Logo" />
        </div>
        <div className="sidebarMenu">
          <div className="scrollableMenu">
            <ul className="nestedMenu">
              {nestedSideBar.map((main, index) => (
                <NavNestedMenu key={index} title={main.title} icon={main.icon}>
                  {main.children.map((inner, innerIndex) => (
                    <NavItem
                      key={innerIndex}
                      title={inner.title}
                      icon={inner.icon}
                      path={inner.path}
                      state={inner.state}
                    />
                  ))}
                </NavNestedMenu>
              ))}
            </ul>
          </div>
          <div className="directlinks">
            <ul className="nestedMenu " style={{ gap: "0.5rem" }}>
              <NavItem
                title={"Notification"}
                icon={<NotificationIm className="sideBarNotificationIcon" />}
                path={"/notification"}
                state={"notification"}
              />
              <NavItem
                title={"Setting"}
                icon={<SettingIm className="sidebarSettingIcon" />}
                path={"/setting"}
                state={"setting"}
              />
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
